import React from 'react';
import styles from './A_ContextMenuItem.module.css';
import cn from 'classnames';

interface A_ContextMenuItemProps {
  onClick: () => void;
  children: React.ReactNode;
  danger?: boolean;
  icon?: React.ReactNode;
}

export default function A_ContextMenuItem({
  children,
  onClick,
  danger = false,
  icon,
}: A_ContextMenuItemProps) {
  return (
    <button
      className={cn(styles.wrapper, danger && styles.danger, 'text-p-4')}
      onClick={onClick}
    >
      {icon}
      {children}
    </button>
  );
}
